<template>
  <div class="main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    reloadApp() {
      console.log('Reloading app');
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/base.scss';

html, body, .main {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-size: 1vh;
}

body {
  background-color: color(body, bg);
  color: color(blue-dark);
  font-family: 'Roboto', sans-serif;
}
</style>
